import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import { validateCustomerEmailSubscriberCondition } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type CustomerEmailSubscriberState = void;

export const CUSTOMER_EMAIL_SUBSCRIBER = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<CustomerEmailSubscriberState>
  >,
): ConditionType<
  CustomerEmailSubscriberState,
  Condition.CustomerEmailSubscriber
> => ({
  name: CONDITION_NAMES[Condition.CUSTOMER_EMAIL_SUBSCRIBER],
  description() {
    return t("Customer is an email subscriber");
  },
  Details(props: ConditionTypeDetailsProps<CustomerEmailSubscriberState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.CUSTOMER_EMAIL_SUBSCRIBER };
  },
  valid() {
    return validateCustomerEmailSubscriberCondition({}).valid;
  },
});
